module.exports = __webpack_public_path__ + "img/logo.6f53a0f1.png";